import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { AppsettingsConfig, IAppsettingsConfig } from './app/modules/client-config/models/client-config';

const salt = new Date().getTime();

fetch(`assets/appsettings.json?${salt}`, { cache: 'no-store' })
  .then((res) => res.json())
  .then((config: IAppsettingsConfig) => {
    if (config.isProduction) {
      enableProdMode();
    }

    platformBrowserDynamic([
      { provide: AppsettingsConfig, useValue: config }
    ])
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  })
  .catch((err) => console.error('Failed to load appsettings.json', err));
